import type { Role } from '@/entities/user';

/** Gateway admin employees API is SUPER_ADMIN; dashboard maps `admin`. */
export const employeesAccessRoles = ['admin'] as const satisfies readonly Role[];
